import * as Styles from '../../../../../../components/PageWrappers/AdDetails/components/DealerEnquiryModal/DealerEnquiryModal.styled';
import { Field, useField } from 'react-final-form';
import { useEffect } from 'react';

import { Checkbox } from '../../../../../../components/Toolkit/Inputs/Checkbox';
import { FORM_VALUES } from '../../../../../../components/PageWrappers/AdDetails/components/DealerEnquiryModal/DealerEnquiryModal.config';

function ShowInterestOptions({
  setShowKeyInfoList,
}: {
  setShowKeyInfoList: (t: boolean) => void;
}) {
  const vehicleTradeIn = useField(FORM_VALUES.VEHICLE_TRADE_IN).input.value;

  useEffect(() => {
    setShowKeyInfoList(vehicleTradeIn);
    // TODO: Clean up this effect's dependencies. We're disabling this lint error for now so we can
    // clean up the lint logs. Ideally we should rewrite this code to be less error prone and trust
    // the lint rule's judgement.
    // https://distilledsch.tpondemand.com/RestUI/Board.aspx#page=userstory/98606
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleTradeIn]);

  return (
    <>
      <Styles.ShowInterestHeader>
        I'm interested in...
      </Styles.ShowInterestHeader>
      <Styles.CheckboxGrid>
        <Field name={FORM_VALUES.FINANCING_VEHICLE}>
          {({ input }) => (
            <Checkbox
              {...input}
              label="Financing this vehicle"
              checked={input.value}
            />
          )}
        </Field>
        <Field name={FORM_VALUES.SCHEDULING_TEST_DRIVE}>
          {({ input }) => (
            <Checkbox
              {...input}
              label="Scheduling a test drive"
              checked={input.value}
            />
          )}
        </Field>
        <Field name={FORM_VALUES.VEHICLE_TRADE_IN}>
          {({ input }) => (
            <Checkbox
              {...input}
              label="Trading in my current vehicle"
              checked={input.value}
            />
          )}
        </Field>
        <Field name={FORM_VALUES.VEHICLE_CONDITION}>
          {({ input }) => (
            <Checkbox
              {...input}
              label="More about the condition"
              checked={input.value}
            />
          )}
        </Field>
      </Styles.CheckboxGrid>
    </>
  );
}

export { ShowInterestOptions };
